<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.43 28.45">
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="transport">
        <path
          class="cls-1"
          d="M28,28.45H.46A.47.47,0,0,1,0,28V11.37a.47.47,0,0,1,.46-.47.47.47,0,0,1,.47.47V27.52H27.51V11.37a.46.46,0,1,1,.92,0V28A.46.46,0,0,1,28,28.45Z"
        />
        <path
          class="cls-1"
          d="M27.86,11.75a.46.46,0,0,1-.29-.1L14.17,1.05.77,11.65a.46.46,0,0,1-.58-.72L13.88.1a.48.48,0,0,1,.58,0L28.15,10.93a.46.46,0,0,1-.29.82Z"
        />
        <path
          class="cls-1"
          d="M21,19.49a.19.19,0,0,1-.13,0l-1.44-1.77L17.7,19.11a.17.17,0,0,1-.23,0,.16.16,0,0,1,0-.22l1.89-1.54a.16.16,0,0,1,.22,0l1.54,1.88a.18.18,0,0,1,0,.23A.19.19,0,0,1,21,19.49Z"
        />
        <path
          class="cls-1"
          d="M21,19.72a.41.41,0,0,1-.3-.14L19.43,18l-1.59,1.3a.38.38,0,1,1-.48-.59l1.89-1.54a.35.35,0,0,1,.28-.08.35.35,0,0,1,.25.14l1.54,1.89a.38.38,0,0,1-.29.62Z"
        />
        <path
          class="cls-1"
          d="M8.85,17.62a.16.16,0,0,1-.12-.06L7.19,15.67a.17.17,0,0,1,0-.22.16.16,0,0,1,.23,0l1.44,1.76,1.76-1.43a.16.16,0,0,1,.23,0,.16.16,0,0,1,0,.22L9,17.58A.13.13,0,0,1,8.85,17.62Z"
        />
        <path
          class="cls-1"
          d="M8.85,17.84a.37.37,0,0,1-.29-.14L7,15.81a.38.38,0,0,1,.06-.54.36.36,0,0,1,.27-.08.36.36,0,0,1,.26.14l1.3,1.59,1.59-1.29a.37.37,0,0,1,.28-.09.4.4,0,0,1,.26.14.4.4,0,0,1,.08.28.4.4,0,0,1-.14.26L9.09,17.75A.34.34,0,0,1,8.85,17.84Z"
        />
        <path
          class="cls-1"
          d="M14.17,22.92a5.48,5.48,0,0,1-4.74-2.74A.15.15,0,0,1,9.48,20,.16.16,0,0,1,9.7,20a5.15,5.15,0,0,0,9.62-2.57.16.16,0,0,1,.16-.16.16.16,0,0,1,.16.16A5.48,5.48,0,0,1,14.17,22.92Z"
        />
        <path
          class="cls-1"
          d="M14.17,23.14a5.7,5.7,0,0,1-4.93-2.85.31.31,0,0,1,0-.28.38.38,0,0,1,.17-.24.4.4,0,0,1,.52.14,4.93,4.93,0,0,0,9.21-2.46.38.38,0,0,1,.76,0A5.69,5.69,0,0,1,14.17,23.14Z"
        />
        <path
          class="cls-1"
          d="M8.85,17.61a.17.17,0,0,1-.16-.16A5.48,5.48,0,0,1,19,14.81a.16.16,0,0,1-.28.16A5.16,5.16,0,0,0,9,17.45.16.16,0,0,1,8.85,17.61Z"
        />
        <path
          class="cls-1"
          d="M8.85,17.83a.38.38,0,0,1-.38-.38,5.69,5.69,0,0,1,10.69-2.74.36.36,0,0,1,0,.29.35.35,0,0,1-.18.22.37.37,0,0,1-.51-.15,4.94,4.94,0,0,0-9.27,2.38A.38.38,0,0,1,8.85,17.83Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.cls-1 {
  fill: #000;
  stroke: #000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.27px;
}
</style>
